import { IconButton, Typography } from '@material-ui/core'
import ShowActionIcon from '@material-ui/icons/Visibility'
import React, { useState } from 'react'

import { RatePlanPolicy } from '../../types/rateplanPolicy'
import RatePlansPoliciesActionModal from './RatePlansPoliciesActionModal'
import useStyles from './styles/RatePlansPoliciesListRow.styles'

interface RatePlansPoliciesListRowMobileProps {
  policiesData: RatePlanPolicy
}
const RatePlansPoliciesListRowMobile: React.FC<
  RatePlansPoliciesListRowMobileProps
> = ({ policiesData }) => {
  const classes = useStyles()
  const [actionModalIsOpen, setactionModalIsOpen] = useState<boolean>(false)
  return (
    <div className={classes.tableRow}>
      <div className={classes.nameCell}>
        <Typography variant="h4">{policiesData.policySet.name}</Typography>
      </div>
      <div>
        <IconButton onClick={() => setactionModalIsOpen(true)}>
          <ShowActionIcon />
        </IconButton>
      </div>
      <RatePlansPoliciesActionModal
        isOpen={actionModalIsOpen}
        onClose={() => setactionModalIsOpen(false)}
        data={policiesData.policySet.policies}
      />
    </div>
  )
}
export default RatePlansPoliciesListRowMobile
